import { createAsyncThunk } from "@reduxjs/toolkit";

import { getShopDetail, updateShopDetail } from "../../helpers/backend_helper";

export interface UpdateShopInfoPayload {
    shopId: string | number;
    data: Record<string, any>;
}

export const getShopInfo = createAsyncThunk(
    "ShopInfo/getShopInfo",
    async (shopId: string | number, { rejectWithValue }) => {
        try {
            const response = await getShopDetail(shopId);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateShopInfo = createAsyncThunk(
    "ShopInfo/updateShopInfo",
    async ({ shopId, data }: UpdateShopInfoPayload, { rejectWithValue }) => {
        try {
            const response = await updateShopDetail(shopId, data);
            return {
                shopId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
